/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import request, { ContentType, RequestParams } from './httpClient'
import {
  DomainInviteUserReq,
  DomainPayoutUpdateReq,
  DomainReferralListResp,
  DomainReferralPayout,
  DomainReferralPayoutListResp,
  DomainUser,
  GetAdminReferralListParams,
  GetAdminReferralPayoutListParams,
  WebResp,
} from './types'

/**
 * @description 邀请用户
 *
 * @tags AdminReferralV1
 * @name PostAdminReferralInviteUser
 * @summary 邀请用户
 * @request POST:/api/v1/admin/referral/invite
 * @response `200` `(WebResp & {
    data?: DomainUser,

})` OK
 */

export const postAdminReferralInviteUser = (param: DomainInviteUserReq, params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: DomainUser
    }
  >({
    path: `/api/v1/admin/referral/invite`,
    method: 'POST',
    body: param,
    type: ContentType.Json,
    format: 'json',
    ...params,
  })

/**
 * @description 推广大使列表
 *
 * @tags AdminReferralV1
 * @name GetAdminReferralList
 * @summary 推广大使列表
 * @request GET:/api/v1/admin/referral/list
 * @response `200` `(WebResp & {
    data?: DomainReferralListResp,

})` OK
 */

export const getAdminReferralList = (query: GetAdminReferralListParams, params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: DomainReferralListResp
    }
  >({
    path: `/api/v1/admin/referral/list`,
    method: 'GET',
    query: query,
    type: ContentType.Json,
    format: 'json',
    ...params,
  })

/**
 * @description 推广大使提现列表
 *
 * @tags AdminReferralV1
 * @name GetAdminReferralPayoutList
 * @summary 推广大使提现列表
 * @request GET:/api/v1/admin/referral/payout/list
 * @response `200` `(WebResp & {
    data?: DomainReferralPayoutListResp,

})` OK
 */

export const getAdminReferralPayoutList = (query: GetAdminReferralPayoutListParams, params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: DomainReferralPayoutListResp
    }
  >({
    path: `/api/v1/admin/referral/payout/list`,
    method: 'GET',
    query: query,
    type: ContentType.Json,
    format: 'json',
    ...params,
  })

/**
 * @description 推广大使提现更新
 *
 * @tags AdminReferralV1
 * @name PutAdminReferralPayoutUpdate
 * @summary 推广大使提现更新
 * @request PUT:/api/v1/admin/referral/payout/update
 * @response `200` `(WebResp & {
    data?: DomainReferralPayout,

})` OK
 */

export const putAdminReferralPayoutUpdate = (param: DomainPayoutUpdateReq, params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: DomainReferralPayout
    }
  >({
    path: `/api/v1/admin/referral/payout/update`,
    method: 'PUT',
    body: param,
    type: ContentType.Json,
    format: 'json',
    ...params,
  })
